// extracted by mini-css-extract-plugin
module.exports = {"tabBox":"solution_tabBox__wEClU"};